<template>
  <!-- <model-179-report /> -->
  <model-238-report />
</template>

<script>
// import Model179Report from "@/views/administration/aeat-reports/179/Model179Report.vue";
import Model238Report from "@/views/administration/aeat-reports/238/Model238Report.vue";

export default {
  components: {
    // Model179Report,
    Model238Report,
  },
};
</script>
